import { Flex, Stack, Text } from '@mantine/core'

import { useShareContent } from '../ShareChart/hooks'
import { ShareModalContentProps, ShareType, SocialType } from '../utils'
import styles from './index.module.css'
import TokenPriceSHareInfo from './TokenPriceShareInfo'
import {
  getBackgroundImage,
  LION_DESC_COLOR,
  SHARE_CHART_BACKGROUND,
  SHARE_CONTENT_SIZE_MAP,
} from './utils'

const LION_IMAGE_SIZE = { w: 580, h: 580 }

const CHART_SIZE = { w: 1060, h: 580 }

export default function FacebookShareContent({
  shareType,
  currentCoinPrices,
  curTimeRange,
  contentContainerRef,
}: ShareModalContentProps) {
  const BackgroundImage = getBackgroundImage(SocialType.facebook, shareType)
  const { shareContent, lionDsc } = useShareContent({
    shareType,
    curTimeRange,
    currentCoinPrices,
  })
  return (
    <Flex
      ref={contentContainerRef}
      {...SHARE_CONTENT_SIZE_MAP[SocialType.facebook]}
      pos={'relative'}
    >
      <Stack align={'center'} flex={1}>
        <TokenPriceSHareInfo
          change={currentCoinPrices?.usd_price_change ?? 0}
          timeRange={curTimeRange}
        />

        <Flex
          {...(shareType === ShareType.Lion ? LION_IMAGE_SIZE : CHART_SIZE)}
          bg={shareType === ShareType.Lion ? 'transparent' : SHARE_CHART_BACKGROUND}
        >
          {shareContent}
        </Flex>
        <Text mt={20} className={styles.lionDsc} c={LION_DESC_COLOR} style={{ fontSize: 45 }}>
          {lionDsc}
        </Text>
      </Stack>
      <BackgroundImage className={styles.shareBackground} />
    </Flex>
  )
}
